import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=4b22ff32&scoped=true&%3Astyle=css&"
import script from "./Error.vue?vue&type=script&lang=js&"
export * from "./Error.vue?vue&type=script&lang=js&"
import style0 from "./Error.vue?vue&type=style&index=0&id=4b22ff32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b22ff32",
  null
  
)

component.options.__file = "Error.vue"
export default component.exports